import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import VueMeta from "vue-meta";
// import "./registerServiceWorker";

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";

// CSS
// import "./assets/css/element-variables.scss";
import "./assets/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/css/font-awesome.min.css";
import "./assets/css/owl.carousel.min.css";
import "./assets/css/owl.theme.default.min.css";
import "./assets/css/colorbox.css";

Vue.config.productionTip = false;

Vue.use(VueMeta);
Vue.use(ElementUI, { locale });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
